import React from 'react'
import { AboutText } from './AboutElements'


import {
    AboutContainer,
    AboutTextWrapper,
    AboutWrapper,
    AboutRow,

    AboutCard,
    AboutH1,
    AboutH2,
    AboutIcon,
    AboutP
} from './AboutElements'


const AboutSection = ({type,lightBg,id,imgStart,title1, title2, title3, title4, p1,p2,p3,p4, Icon1, Icon2,Icon3,Icon4}) => {
    return (
        <>
            <AboutContainer id='about'>
                <AboutTextWrapper>
                    <AboutH1>About</AboutH1>
                </AboutTextWrapper>
                <AboutWrapper>
                    <AboutRow>
                        <AboutCard white={true}> 
                            <AboutH2>{title1}</AboutH2>
                                <AboutP>{p1}</AboutP>
                        </AboutCard>
                        <AboutCard white={true}> 
                             <AboutH2>{title2}</AboutH2>

                                <AboutP>{p2}</AboutP>
                        </AboutCard>
                        <AboutCard white={true}> 
                                <AboutText>
                                We have more than <b>20 years of experience </b> in different special manufacturing processes, such as <b>conventional and CNC maquining.</b>
                                </AboutText>
                                <AboutText>
                                We create a team specialized in <b>industrial automation </b> with experience in the most demanding standards of the <b>automotive, aerospace and medical </b> industries.
                                </AboutText>
                        </AboutCard>
                    </AboutRow>
                </AboutWrapper>
            </AboutContainer>
        </>
    )
}

export default AboutSection
